import { Form, Modal, Button } from "react-bootstrap";
import { update } from "./services/upload-files.service";
import { useState, useRef } from "react";

const EditCompanyInformation = ({ activeTab, handleInputChange, formData, setLoading, setFormData, userdetails }) => {
    const [validationErrors, setValidationErrors] = useState({});
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const fileInputRef = useRef(null); 

    const handleInputChangeLocal = (event) => {
        const { name, value, files } = event.target;
        if (name === "company_info__company_logo") {
            const logoFile = files[0];
            setFormData((prev) => ({
                ...prev,
                company_info: {
                    ...prev.company_info,
                    company_logo: logoFile, 
                },
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                company_info: {
                    ...prev.company_info,
                    [name.split("__")[1]]: value, 
                },
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateFormFields(formData);
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
        } else {
            try {
                setLoading(true);
                let fData = new FormData();
                fData.append("user", JSON.stringify(formData.user));
                fData.append("personal_info", JSON.stringify(formData.personal_info));
                fData.append("company_info", JSON.stringify(formData.company_info));
                if (formData.company_info.company_logo) {
                    fData.append("company_info[company_logo]", formData.company_info.company_logo);
                }
                const res = await update(fData, `users/profile/${userdetails.id}`);
                if (res && res.success) {
                    setValidationErrors({ success: 'Successfully Registered' });
                    setLoading(false);
                    setFormData(res);
                    setShowSuccessModal(true);

                    
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                } else {
                    setValidationErrors({ err: 'Please Enter Valid Information' });
                }
            } catch (error) {
                setValidationErrors({ err: 'An Error Occurred. Please Try Again Later.' });
            }
        }
    };

    const validateFormFields = (formData) => {
        const errors = {};
        const isAlphabetic = (str) => str.split('').every(char => /^[a-zA-Z\s]+$/.test(char));
        const isNumeric = (str) => str.split('').every(char => /^\d+$/.test(char));
        const isLength = (str, length) => str.length === length;

        if (!formData.company_info || !formData.company_info.name || formData.company_info.name.trim() === "") {
            errors.company_info = { ...errors.company_info, name: "Please Enter Company Name" };
        } else if (!isAlphabetic(formData.company_info.name)) {
            errors.company_info = { ...errors.company_info, name: "Name Should Contain Only Letters" };
        }
        if (!formData.company_info || !formData.company_info.phone || formData.company_info.phone.trim() === "") {
            errors.company_info = { ...errors.company_info, phone: "Please Enter a Company Phone Number" };
        } else if (!isNumeric(formData.company_info.phone) || !isLength(formData.company_info.phone, 10)) {
            errors.company_info = { ...errors.company_info, phone: "Please Enter a Valid Company Phone Number" };
        }
        if (!formData.company_info || !formData.company_info.email || formData.company_info.email.trim() === "") {
            errors.company_info = { ...errors.company_info, email: "Please Enter a Company Email Address" };
        } else {
            const emailInput = document.createElement('input');
            emailInput.type = 'email';
            emailInput.value = formData.company_info.email;
            if (!emailInput.checkValidity()) {
                errors.company_info = { ...errors.company_info, email: "Please Enter a Valid Company Email Address" };
            }
        }
        if (!formData.company_info || !formData.company_info.city || formData.company_info.city.trim() === "") {
            errors.company_info = { ...errors.company_info, city: "Please Enter a Company City" };
        } else if (!isAlphabetic(formData.company_info.city)) {
            errors.company_info = { ...errors.company_info, city: "City Should Contain Only Letters" };
        }
        if (!formData.company_info || !formData.company_info.state || formData.company_info.state.trim() === "") {
            errors.company_info = { ...errors.company_info, state: "Please Enter a Company State" };
        } else if (!isAlphabetic(formData.company_info.state)) {
            errors.company_info = { ...errors.company_info, state: "State Should Contain Only Letters" };
        }
        if (!formData.company_info || !formData.company_info.country || formData.company_info.country.trim() === "") {
            errors.company_info = { ...errors.company_info, country: "Please Enter a Company Country" };
        } else if (!isAlphabetic(formData.company_info.country)) {
            errors.company_info = { ...errors.company_info, country: "Country Should Contain Only Letters" };
        }
        if (!formData.company_info || !formData.company_info.pin || formData.company_info.pin.trim() === "") {
            errors.company_info = { ...errors.company_info, pin: "Please Enter a Company Pincode" };
        } else if (!isNumeric(formData.company_info.pin) || !isLength(formData.company_info.pin, 6)) {
            errors.company_info = { ...errors.company_info, pin: "Please Enter a Valid 6-Digit Company Pincode" };
        }
        if (formData.company_info && formData.company_info.company_logo) {
            const logoFile = formData.company_info.company_logo;
            const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
            const maxSize = 2 * 1024 * 1024;
            if (!allowedTypes.includes(logoFile.type)) {
                errors.company_info = { ...errors.company_info, company_logo: "Logo Must Be a JPEG, PNG, or GIF file" };
            } else if (logoFile.size > maxSize) {
                errors.company_info = { ...errors.company_info, company_logo: "Logo File Size Must Be Less Than 2MB" };
            }
        }
        return errors;
    };

    return (
        <>
            <div
                className={`tab-pane fade ${activeTab === 'company-information' ? 'show active' : ''}`}
                id="nav-supplier"
                role="tabpanel"
                aria-labelledby="nav-supplier-tab"
            >
                <div className='row'>
                    <div className='col-4'>
                        <div className='editprofile'>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="fname">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="company_info__name"
                                        value={formData.company_info ? formData.company_info.name || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.name}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="companyLogo">
                                    <Form.Label>Company Logo</Form.Label>
                                    <Form.Control
                                        type="file"
                                        name="company_info__company_logo"
                                        ref={fileInputRef}
                                        onChange={handleInputChangeLocal}
                                    />
                                    {validationErrors.company_info && 
                                    <div className="error login-error">{validationErrors.company_info.company_logo}</div>}
                                    
                                   
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="lname">
                                    <Form.Label>Phone</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="company_info__phone"
                                        value={formData.company_info ? formData.company_info.phone || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.phone}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="cemail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="company_info__email"
                                        value={formData.company_info ? formData.company_info.email || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.email}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="city">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="company_info__city"
                                        value={formData.company_info ? formData.company_info.city || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.city}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="state">
                                    <Form.Label>State</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="company_info__state"
                                        value={formData.company_info ? formData.company_info.state || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.state}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="country">
                                    <Form.Label>Country</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="company_info__country"
                                        value={formData.company_info ? formData.company_info.country || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.country}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="pcode">
                                    <Form.Label>Pincode</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="company_info__pin"
                                        value={formData.company_info ? formData.company_info.pin || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.pin}</div>}
                                </Form.Group>
                                <button className="btn btn-primary btn-add mb-3" type='submit'>Save</button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditCompanyInformation;